import { Parser } from 'html-to-react';

const htmlParser = (html: string): React.ReactNode => {
  const reactParser = Parser();
  return reactParser.parse(html);
};

export default htmlParser;
